import { useEffect } from 'react';
import cn from 'classnames';
import Marquee from 'react-fast-marquee';
import { Link } from 'react-router-dom';
import { 
  Swiper, 
  SwiperSlide,
} from 'swiper/react';
 import { 
  Pagination,
  Autoplay,
} from 'swiper/modules';

import LoveSection from './LoveSection';
import HowItWorkSection from './HowItWorkSection';
import UsersSaysSection from './UsersSaysSection';
// import Rating from '../../components/Rating/Rating';
// import MainHeader from '../../components/MainHeader/MainHeader';
// import MainFooter from '../../components/MainFooter/MainFooter';
import VideoButton from '../../components/VideoButton/VideoButton';
import PageWithHeader from '../../components/PageWithHeader/PageWithHeader';
import styles from './Dev.module.css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import bannerVideo from '../../assets/videos/baner.webm';
import bannerVideoMp4 from '../../assets/videos/baner.mp4';

const faqItems = [
  {
    question: 'How will an AI meal planner know what to recommend?',
    answer: `
      We’ve trained it well. By getting to know your body type, activity level, dietary restrictions and personal goals, our AI can build a meal plan that’s right for you.
    `,
    green: true,
  },
  {
    question: 'I have allergies. Will they be accommodated?',
    answer: `
      They sure will! From preferences to intolerances, you can swap ingredients whenever, for whatever reason. All it takes is one click. 
    `
  },
  {
    question: 'I’m not a great cook. Is an AI meal plan right for me?',
    answer: `
      In short, absolutely. As long as you follow our step-by-step videos, there’s no room for error.
    `,
  },
  {
    question: 'I’m new to the world of health and fitness. Can a meal plan builder help?',
    answer: `
      Yes! In fact, there’s no easier way to kickstart your health journey, than handing the reins over to an app that does it all. From newbies feeling overwhelmed to fitness enthusiasts looking to level up, we’re here.
    `,
    green: true,
  },
];

const Dev = () => {

  useEffect(() => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
  }, []);

  return (
    <PageWithHeader>
      <section className={cn(styles.bannerSection, styles.videoSection)}>
        <VideoButton 
          link="https://www.youtube.com/embed/p9DPgK_zfWY"
          className={styles.watchVideoTopButton}
        />
        <video 
          className={styles.bannerVideo} 
          autoPlay
          muted
          loop
          playsInline
        >
          <source
            src={bannerVideo}
            type="video/webm"
          />
          <source
            src={bannerVideoMp4}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </section>
      <LoveSection />
      <HowItWorkSection />
      <section className={cn(styles.bannerSection, styles.nextDaySection)}>
        <div className={styles.marque}>
          <Marquee autoFill>
            <div className={styles.marqueItem}>Weekly plan</div>
            <div className={styles.marqueItem}>Everyday</div>
            <div className={styles.marqueItem}>Groceries</div>
            <div className={styles.marqueItem}>Stress-Free</div>
            <div className={styles.marqueItem}>no food waste</div>
          </Marquee>
        </div>
        <div className={styles.bannerInfoBlock}>
          <div className={styles.bannerInfoWrapper}>
            <div className={styles.bannerTitle}>
              Ready to eat healthier? Download the Meal Well app today!
            </div>
            <div className={styles.bannerSubTitle}>
              You’ll see how far you’ve come with just one click.
            </div>
            <Link 
              to="/get-app"
              className={styles.greenButton}
            >
              Download App
            </Link>
          </div>
        </div>
        {/* <div className={cn(styles.marque, styles.shopMarque)}>
          <Marquee autoFill>
            <div className={cn(styles.shopMarqueItem, styles.waitrose)} />
            <div className={cn(styles.shopMarqueItem, styles.morrison)} />
            <div className={cn(styles.shopMarqueItem, styles.tesko)} />
            <div className={cn(styles.shopMarqueItem, styles.sainsburys)} />
          </Marquee>
        </div> */}
      </section>
      <UsersSaysSection />
      <section className={cn(styles.section, styles.whatSaySection)}>
        <div className={styles.tryFreeToday}>
          <div className={styles.tryContent}>
            <div className={styles.title}>TRY US FOR FREE.</div>
            <div className={styles.subTitle}>
              Your personal AI nutritionist, at your fingertips.
            </div>
            <a 
              className={styles.downloadLink} 
              href="https://apps.apple.com/gb/app/mealwell-diet-food-planner/id6743499265" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Download for free
            </a>
          </div>
        </div>
      </section>
      <section className={cn(styles.section, styles.faqSection)}>
        <div className={styles.sectionTitle}>
          FAQ
        </div>
        <div className={styles.faqItems}>
          {faqItems.map((faqData, index) => (
            <div key={index} className={cn(styles.faqItem, { [styles.faqItemGreen]: faqData.green })}>
              <div className={styles.faqTitle}>
                {faqData.question}
              </div>
              <div className={styles.faqText}>
                {faqData.answer}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.faqMobileItems}>
          <Swiper 
            modules={[Pagination, Autoplay]}
            className={styles.slider} 
            spaceBetween="24" 
            slidesPerView="1" 
            navigation
            pagination={{ 
              clickable: true,
            }}
            autoplay={{ 
              delay: 3000,
              disableOnInteraction: false,
            }} 
            loop   
          >
            {faqItems.map((faqData, index) => (
              <SwiperSlide key={index} className={styles.loveSliderSlide}>
                <div key={index} className={cn(styles.faqItem, { [styles.faqItemGreen]: faqData.green })}>
                  <div className={styles.faqTitle}>
                    {faqData.question}
                  </div>
                  <div className={styles.faqText}>
                    {faqData.answer}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      <section className={cn(styles.section, styles.needHelpSection)}>
        <div className={styles.sectionTitle}>
          Need Help?
        </div>
        <div className={styles.sectionSubTitle}>
          If you have any questions, issues or need assistance, feel free to reach out to us. 
        </div>
        <Link 
          to="/support"
          className={styles.greenButton}
        >
          Contact us
        </Link>
      </section>
    </PageWithHeader>
  );
};

export default Dev;
